import { AfterViewInit, Directive } from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';

@Directive({
  selector: '[tabSelect]'
})
export class TabDirective implements AfterViewInit {

  constructor(private auto: MatAutocomplete) { console.log("inuse")}
  ngAfterViewInit() {
    this.auto._keyManager.onKeydown = (event: KeyboardEvent) => {
      switch (event.code) {
        case 'Tab':
          if (this.auto.isOpen) {
            const option = this.auto.options.find(x => x.active);
            if (option) {
              option.select();
              //event.preventDefault();
              return;
            }
          }
          this.auto._keyManager.tabOut.next();
          break;
        case 'ArrowDown':
          this.auto._keyManager.setNextItemActive();
          break;

        case 'ArrowUp':
          this.auto._keyManager.setPreviousItemActive();
          break;
      }
    };
  }
}